export default __webpack_public_path__ + "static/media/logo-Saint-Gobain.f294f552.png";